export const UMAIL_ACTIVATED = "UMAIL_ACTIVATED";
export const DISMISS_UMAIL = "DISMISS_UMAIL";

export const POST_UMAIL_MESSAGE_STARTED = "POST_UMAIL_MESSAGE_STARTED";
export const POST_UMAIL_MESSAGE_SUCCEEDED = "POST_UMAIL_MESSAGE_SUCCEEDED";
export const POST_UMAIL_MESSAGE_FAILED = "POST_UMAIL_MESSAGE_FAILED";
